<button mat-icon-button [matMenuTriggerFor]="langMenu" class="lang-selector-container" aria-label="language-selector"
    [matTooltip]="languageSelectTooltip">
    <mat-icon class="svgIcon" svgIcon="{{currCountry?.flagImage}}"></mat-icon>
</button>
<mat-menu #langMenu="matMenu" class="lang-selector-menu-list">
    @for (country of countries; track country) {
    <div mat-menu-item (click)="selectionChange(country.languageCd)">
        <mat-icon class="svgIcon flag-icon" svgIcon="{{country.flagImage}}"></mat-icon>
        <span class="country-flag">{{country?.Name}}</span>
    </div>
    }
</mat-menu>